export const GET_PLAYERS = 'GET_PLAYERS';
// Channel
export const GET_TV_SHOWS = 'GET_TV_SHOWS';
export const HANDLE_TV_SHOWS_ERROR = 'HANDLE_TV_SHOWS_ERROR';

// Video
export const GET_VIDEO_PLAYLIST_START = 'GET_VIDEO_PLAYLIST_START';
export const GET_VIDEO_PLAYLIST = 'GET_VIDEO_PLAYLIST';
export const RESET_VIDEO_PLAYLIST = 'RESET_VIDEO_PLAYLIST';

// Personal
export const GET_PERSONAL_CONTENT = 'GET_PERSONAL_CONTENT';
export const UPDATE_PERSONAL_ITEM = 'UPDATE_PERSONAL_ITEM';
export const RESET_PERSONAL_CONTENT = 'RESET_PERSONAL_CONTENT';

// Schedule
export const GET_SCHEDULE = 'GET_SCHEDULE';
export const HANDLE_SCHEDULE_ERROR = 'HANDLE_SCHEDULE_ERROR';

// Client
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const APISERVICE_INITIALIZED = 'APISERVICE_INITIALIZED';
export const LANGUAGE_CHANGED = 'LANGUAGE_CHANGED';
export const HIDE_SCORE_CHANGED = 'HIDE_SCORE_CHANGED';

// Fav Team
export const GET_FAV_TEAM = 'GET_FAV_TEAM';
export const GET_FAV_TEAM_PROGRAMS_START = 'GET_FAV_TEAM_PROGRAMS_START';
export const GET_FAV_TEAM_PROGRAMS = 'GET_FAV_TEAM_PROGRAMS';
export const RESET_FAV_TEAM = 'RESET_FAV_TEAM';
export const HANDLE_FAV_TEAM_ERROR = 'HANDLE_FAV_TEAM_ERROR';

// Page Nav
export const GET_PAGE_NAV_START = 'GET_PAGE_NAV_START';
export const GET_PAGE_NAV = 'GET_PAGE_NAV';
export const HANDLE_PAGE_PAV_ERROR = 'HANDLE_PAGE_PAV_ERROR';

// Video List
export const GET_NBA_VIDEO_LIST_START = 'GET_NBA_VIDEO_LIST_START';
export const GET_NBA_VIDEO_LIST = 'GET_NBA_VIDEO_LIST';
export const HANDLE_VIDEO_LIST_ERROR = 'HANDLE_VIDEO_LIST_ERROR';

// Fav Videos
export const GET_FAV_VIDEOS = 'GET_FAV_VIDEOS';
export const GET_FAV_VIDEOS_START = 'GET_FAV_VIDEOS_START';
export const RESET_FAV_VIDEOS = 'RESET_FAV_TEAM';
export const HANDLE_FAV_VIDEOS_ERROR = 'HANDLE_FAV_VIDEOS_ERROR';

// Recommended
export const GET_RECOMMENDED = 'GET_RECOMMENDED';
export const GET_RECOMMENDED_START = 'GET_RECOMMENDED_START';
export const RESET_RECOMMENDED = 'RESET_RECOMMENDED';
export const HANDLE_RECOMMENDED_ERROR = 'HANDLE_RECOMMENDED_ERROR';

// History
export const GET_HISTORY = 'GET_HISTORY';
export const RESET_HISTORY_START = 'RESET_HISTORY_START';
export const RESET_HISTORY = 'RESET_HISTORY';
export const HANDLE_HISTORY_ERROR = 'HANDLE_HISTORY_ERROR';
